<template>
    <div class="new_indexAdmin">
         <div class="u-max-width  ERPShopAdminbanner">
               <!-- <video class="indexVideo" autoplay muted  loop x5-video-player-type="h5" 
               x5-video-orientation="portraint" webkit-playsinline playsinline  x5-playsinline
               src="../../../assets/images/newImg/index2.mp4"> </video>   -->
    
               <div class="ERPShop-bannnertext">
                  <div class="ERPShop-bannnertext1" style="color:#127bf2 ">创芯物联网卡</div>
                  <div class="ERPShop-bannnertext2" style="color:#000 ">专业、 稳定、安全、迅捷，助力万物互联</div>
               </div>
             
        </div>
          <div class="u-max-width  ERPShopAdminbannergif">
               <img src="../../../assets/images/newImg/indexGif.gif">
              
               <!-- <div class="ERPShop-bannnertext">
                  <div class="ERPShop-bannnertext1">ONEBO一件分销出海平台</div>
                  <div class="ERPShop-bannnertext2">简单做跨境，一产品卖全球</div>
                  <div class="ERPShop-bannnerbtn">
                       <div class="bannnerbtn" @click="handleClick('/corporationAdmin')">立即查看</div>
                  </div>
               </div> -->
             
        </div>
        <div class="u-max-width u-p-t-100 u-p-b-100" style="background:#FFF"> 
            <div class="u-min-width u-flex u-row-center u-col-center" style="flex-direction: column;">
                <div class="u-m-t-80 u-flex u-row-center u-col-center">
                    <div style="width:50%">
                        <h1 style="color:#127bf2" class="u-m-b-50">什么是物联网卡？</h1>
                        <div class="u-m-b-50">物联卡是三大运营商（移动、联通、电信）基于物联网专网，面向物联网用户提供的移动通信接入业务。采用三网专属号段，通过专用网元设备支持短信、无线数据和语音等基础通信服务，提供通信链接管理和终端管理等智能通道服务。可用于各种物联网设备的应用场景，如POS机、仪表、车联网、物流监控、智能家居、穿戴设备、共享单车、移动支付、环境监测和智慧农业等。</div>
                        <div class="u-flex  u-col-center">
                            <img class="u-m-r-50" src="../../../assets/myimage/yd.webp" alt="">
                            <img class="u-m-r-50" src="../../../assets/myimage/lt.webp" alt="">
                            <img src="../../../assets/myimage/dx.webp" alt="">
                        </div>
                    </div>
                    <div style="width:50%">
                        <img src="../../../assets/myimage/image.webp" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="recruitmentItem5 u-p-t-40  u-max-width">
             <div class="u-min-width u-m-t-60 u-p-b-160 supplierAdminItem4">
                   <ul class="supplierAdminItem4-ul u-flex u-row-between">
                        <li>
                            <div class="u-flex u-row-center" style="width:100%">
                                <img style="width:100%" src="../../../assets/myimage/liuliangka.webp">
                            </div>
                            <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">流量卡</div>
                                    <div class="ul-li-titlt2 u-m-t-20">提供移动/电信/联通各运营商不同规格流量卡</div>
                                 </div>
                            </div>
                            
                        </li>
                         <li>
                            <div class="u-flex u-row-center" style="width:100%">
                                <img style="width:100%" src="../../../assets/myimage/yuyinka.jpg">
                            </div>
                             <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">语音卡</div>
                                    <div class="ul-li-titlt2 u-m-t-20">覆盖广、连接大、功耗低、成本低等优点</div>
                                 </div>
                            </div>
                        </li>
                        <li>
                            <div  class="u-flex u-row-center" style="width:100%">
                                 <img style="width:100%" src="../../../assets/myimage/nbka.webp">
                            </div>
                             <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">NB卡</div>
                                    <div class="ul-li-titlt2 u-m-t-20">覆盖广、连接大、功耗低、成本低等优点。</div>
                                 </div>
                            </div>
                        </li>
                        <li>
                            <div class="u-flex u-row-center" style="width:100%">
                                 <img style="width:100%" src="../../../assets/myimage/esim.webp">
                            </div>
                             <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">e-SIM卡</div>
                                    <div class="ul-li-titlt2 u-m-t-20">连接上网、接播电话、发短信，无需在设备上再插入实体卡</div>
                                 </div>
                            </div>
                           
                        </li>
                         <li>
                            <div class="u-flex u-row-center" style="width:100%">
                                <img style="width:100%" src="../../../assets/myimage/guoji.jpg">
                            </div>
                             <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">国际物联网卡</div>
                                    <div class="ul-li-titlt2 u-m-t-20">通过国际物联网协议，为客户海外设备提供联网服务</div>
                                 </div>
                            </div>
                          
                        </li>
                   </ul>
             </div>
        </div>
        <div class="recruitmentItem6" >
            <div class=" youshi">
               <div class="u-min-width">
                <h1 class="u-row-center" style="margin-bottom:100px;font-size:32px">创芯物联网卡优势</h1>
                <div class="u-flex   youshiItem">
                    <div>
                        <h2>覆盖全球</h2>
                        <div>提供移动/电信/联通/国际物联网卡快速开展各地业务</div>
                    </div>
                    <div>
                        <h2>AI智能通信</h2>
                        <div>AI语音外呼成AI短信发送卡片激活及充值续费提醒</div>
                    </div>
                    <div>
                        <h2>在线监控</h2>
                        <div>实时监控物联网卡运营情况及流量消耗</div>
                    </div>
                    <div>
                        <h2>灵活计费</h2>
                        <div>可根据全规格物联网卡套餐可根据业务需求自由调整</div>
                    </div>
                </div>
                <div class="u-flex   youshiItem">
                    <div>
                        <h2>流量预警</h2>
                        <div>物联网卡全国无漫游快速开展各地业务</div>
                    </div>
                    <div>
                        <h2>流量池共享</h2>
                        <div>物联网卡流量池共享、灵活控制企业成本</div>
                    </div>
                    <div>
                        <h2>业务报表</h2>
                        <div>提供多维度的业务报表统计及分析</div>
                    </div>
                    <div>
                        <h2>安全可靠</h2>
                        <div>专用物联网通道数据传输安全性高</div>
                    </div>
                    </div>
               </div>
          
            </div>
        </div>
        <myNewFoot :show="false"></myNewFoot>
    </div>
</template>
<script>
import BMap from "BMap"
import myNewMenu from "@/components/newcomponents/myNewMenu"
import myNewFoot from "@/components/newcomponents/myNewFoot"
import myContern from "@/components/newcomponents/myContern"
export default {
    name:'new_indexAdmin',
    data(){
        return {

        }
    },
    components:{
        myNewMenu,
        myNewFoot,
        myContern
    },
    mounted() {
        // this.menuSeen()
        // window.addEventListener('scroll', this.handleScroll)
        // this.sliders = [
        //     {
        //         img: require("../assets/slider/a1.jpg")
        //     },
        //     {
        //         img: require("../assets/slider/a2.jpg")
        //     },
        //     {
        //         img: require('../assets/slider/a3.jpg')
        //     },
        //     {
        //         img: require('../assets/slider/a4.jpg')
        //     }
        // ]

        let map = new BMap.Map("AddressMap");
        
        var point = new BMap.Point(113.877281,22.585669);
        map.centerAndZoom(point, 14);
        map.enableScrollWheelZoom();
        var marker = new BMap.Marker(point);// 创建标注
        map.addOverlay(marker);             // 将标注添加到地图中
    },
    methods:{
          handleClick(url){
            this.$router.push({
                path:url
            })
          }
    }
    
}
</script>
<style lang="scss" scoped>
 .new_indexAdmin{
    font-family: PingFang SC-Regular, PingFang SC;
    .generalViewTitle{
        position: relative;
   }
   #AddressMap {
    width: 1200px;
    height: 500px;
    margin: 0 auto;
}
   .generalViewTitle1{
        font-size: 90px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        opacity: 0.6;
   }
    .generalViewTitle2{
       position: absolute;
       z-index: 10;
       top: 50%;
       left: 0;
       transform: translateY(-50%);
       font-size: 38px;
       font-family: PingFang SC-Semibold, PingFang SC;
       font-weight: 600;
       color: #FFF;
   }
     .ERPShopAdminbanner{
        //  background: url("../../../assets/images/newImg/indexGif.gif");
        //  background-size: 100% 100%;
         height: 600px;
         .indexVideo{
            width: 100%;
            height: 100%;
          
         }
         .ERPShop-bannnertext{
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            height:600px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background-image: url("../../../assets/myimage/banner.webp") ;
            background-size:cover ;
            .ERPShop-bannnertext1{
                font-size: 78px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
            }
            .ERPShop-bannnertext2{
               margin-top: 100px;
               font-size: 40px;
               font-family: PingFang SC-Regular, PingFang SC;
               font-weight: 400;
               color: #FFF;
            }
            .ERPShop-bannnerbtn{
                display: flex;
                margin-top: 100px;
                & div{
                    width: 200px;
                    height: 45px;
                    line-height: 45px;
                    text-align: center;
                    font-size: 18px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    cursor: pointer;
                }
                .bannnerbtn{
                    background: linear-gradient(90deg, #FC6B1D 0%, #F98F43 100%);
                    color: #fff;
                }
                .bannnerbtn2{
                    margin-left: 20px;
                    
                    color: #FD681C

                }
            }
         }
    }
    .ERPShopAdminbannergif{
        display:none;
       
    }
   .indexTitle1{
       font-size: 40px;
       font-family: PingFang SC-Semibold, PingFang SC;
       font-weight: 600;
       color: #000000;
       background: transparent;
       position: relative;
       z-index: 10;
   }
   .zizhi{
    display: flex;
    justify-content: space-between;
    align-items: center;
   }
   .zizhi img{
  width: 130px;
  height: 180px;
   }
   .indexTitle1:before{
        content: '';
        display: inline-block;
        width:110%;
        height: 10px;
        background:  #FC7632 ;
        position: absolute;
        left: 50%;
        bottom: 2px;
        z-index: -1;
        transform: translateX(-50%);
   }
   .indexTitle2{
       font-size: 16px;
       font-family: PingFang SC-Regular, PingFang SC;
       font-weight: 400;
       color: #999999;
   }
   .indexTitle3{
       font-size: 16px;
       font-family: PingFang SC-Regular, PingFang SC;
       font-weight: 400;
       color: #333333;
       padding: 0 200px;
       text-align: center;
   }
  
   .recruitmentItem5{
        background: #010101;
       .supplierAdminItem4{
        .supplierAdminItem4Title{
            font-size: 26px;
            text-align: center;
            font-weight: 600;
            color: #000000;
        }
        .supplierAdminItem4Title2{
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            text-align: center;
        }
        .supplierAdminItem4-ul{
            li{
                width: 300px;
                height: 320px;
                background:#FFF ;
                box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                 overflow: hidden;
                 position: relative;
                 cursor: pointer;
                .supplierAdminItem4box{
                    position: absolute;
                    bottom:  -70px;
                    left: 0;
                    background: #FFF;
                    transition:bottom 1s ease-in-out ;
                     .ul-li-titlt1{
                            font-size: 21px;
                            font-family: PingFang SC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #010101;
                            text-align: left;
                        }
                        .ul-li-titlt2{
                            font-size: 15px;
                            font-family: PingFang SC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #555555;
                            text-align: left;
                            height: 65px;
                        
                        }
                }
                &:hover{
                    .supplierAdminItem4box{
                        bottom:0;
                    }
                }
               
            }
        }
    }
   }
   .youshi{
    height: 540px;
    width: 100%;
    padding: 4rem 0 3.5rem 0;
    text-align: center;
    background: url('../../../assets/myimage/bg.webp') center center / cover no-repeat;
    color: #fff;
     .youshiItem >div{
        width: 25%;
        text-align: center;
        height: 160px;
        h2{
            font: 1.5rem;
            font-weight: bold;
            margin-bottom: 20px;
        }
        :last-child{
            font-size: 16px;
            width: 250px;
            margin: 0 auto;
        }
     }
   }
    .recruitmentItem6View{
       display: flex;
       justify-content: space-between;
       align-items: center;
       background: #f7f9fc;
       position: relative;
       .recruitmentItem6View-img{
        margin: 0 auto;
        
     }
     .recruitmentItem6ViewItem{
        width: 179px;
        height: 83px;
        border: 1px solid;
        position: absolute;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        -o-border-image: linear-gradient(0deg, #127bf2, #c1deff) 10 10;
        border-image: linear-gradient(0deg, #127bf2, #c1deff) 10 10;
        .mytitle{
            font-size:2.25rem;
            color: #127bf2;
        }
        .ctitle{
            font-size:.875rem;
            color: #343e4c;
        }
       }
       .recruitmentItem6ViewItem1{
        top: 2%;
        left: 15%;
       }
       .recruitmentItem6ViewItem2{
        top: 5%;
        right: 8%;
       }
       .recruitmentItem6ViewItem3{
        bottom: 8%;
        left:25%;
       }
   }
   
   .recruitmentItem7{
        background: #000000;
   }
 
   .generalItemView{
      display: flex;
      justify-content: space-between;
      align-items: center;
   }
   .generalItem{
      color: #fff;
   }
   .generalItemtext1{
        font-size: 28px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #f1f1f1;
   }
   .generalItemtext2{
        font-size: 18px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #666666;
   }
   
 }
 
</style>
<style lang="scss" scoped>
/*手机端*/
@media  screen and (max-width:760px) {
    .generalViewTitle1{
        font-size: 40px !important;
       
   }
    .generalViewTitle2{
       font-size: 18px !important;
   }
    .ERPShopAdminbanner{
        display: none !important;
         height: 190px !important;
         position: relative;
         .indexVideo{
            width: 100%;
            height: 190px !important;
         }
         .ERPShop-bannnertext{
            .ERPShop-bannnertext1{
                font-size: 20px !important;
                margin-top: 60px;
            }
            .ERPShop-bannnertext2{
               margin-top: 20px !important;
               font-size: 12px !important;
            }
            .ERPShop-bannnerbtn{
                display: flex;
                margin-top: 20px !important;
                & div{
                    width: 90px !important;
                    height: 25px !important;
                    line-height: 25px !important;
                    font-size: 12px !important;
                }
              
            }
         }
    }

    .ERPShopAdminbannergif{
        display:block !important;
         height: 190px !important;
         & img{
            width: 100%;
            height: 190px !important;
         }
    }
   .indexTitle1{
       font-size:24px !important;
       
   }
   .indexTitle1:before{
        height: 4px !important;
       
   }
   .indexTitle2{
       font-size: 16px;
   }
   .indexTitle3{
       font-size: 14px !important;
       padding: 0 10px !important;
   }
   .indeximg1{
       width:96%;
   }
     .recruitmentItem5{
        background: #010101;
       .supplierAdminItem4{
        .supplierAdminItem4Title{
            font-size: 26px;
            text-align: center;
            font-weight: 600;
            color: #000000;
        }
        .supplierAdminItem4Title2{
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            text-align: center;
        }
        .supplierAdminItem4-ul{
            flex-direction: column;
            li{
                width: 100% !important;
                height: 457px;
                background:#FFF ;
                box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                 overflow: hidden;
                 position: relative;
                 cursor: pointer;
                 margin-bottom: 16px !important;
                .supplierAdminItem4box{
                    position: absolute;
                    bottom:  -140px;
                    left: 0;
                    bottom:0 !important;
                    
                }
               
               
            }
        }
    }
   }
    .recruitmentItem6View{
       display: flex;
       flex-direction: column;
       position: relative;
       background: #f7f9fc;
       .recruitmentItem6View-img{
        margin: 0 auto;
      }
       .recruitmentItem6ViewItem{
        width: 179px;
        height: 83px;
        border: 1px solid;
        -o-border-image: linear-gradient(0deg, #127bf2, #c1deff) 10 10;
        border-image: linear-gradient(0deg, #127bf2, #c1deff) 10 10;
       }
   }
   
   .recruitmentItem7{
        background: #000000;
   }
 
   .generalItemView{
     flex-direction: column;
   }
   .generalItem{
      width: 100% !important;
      height: 610px;
      background: #FFFFFF;
   }
   .generalItem img{
       width: 100%;
       height: 457px;
   }
   .generalItemtext1{
        font-size: 28px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
   }
   .generalItemtext2{
        font-size: 18px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #666666;
   }
   
}
</style>
